import React, { FC, useEffect, useReducer, useRef, useState } from 'react'
import { Popup } from '../../catalog/Popup'
import styled from 'styled-components'

import { PartialLine } from '../../../logic/pools/process-pools'
import { SubNavigator } from '../../catalog/SubNavigator'
import { OneAssetPanel } from './OneAssetPanel'
import { MultiAssetPanel } from './MultiAssetPanel'
import {
  DepositResult,
  getOneAssetJoinTokens,
} from '../../../api/web3/deposit-api'
import { Settings } from '../../swap/Settings'
import { oracleApi } from '../../../api/oracle/oracle-client'
import { defaultSlippage } from '../../../config'
import { Gear } from '../../catalog/icons/Gear'
import {
  createEarnTabEvent,
  createSuccessEvent,
  DepositMode,
} from 'user-events-segment'
import { listTokens } from '../../../logic/pools/Pool'
import { InjectedWindow } from '../../../utils/types'
import { Amounts } from '../../../logic/token/amounts'
import { fromWei } from '../../../utils/static-web3'
import { depositReducer } from './deposit-reducer'
declare const window: InjectedWindow
interface Props {
  onExit: VoidFunction
  onDeposit: (deposit: DepositResult) => void
  line: PartialLine
}

type OptionTab = '1-asset' | 'all-asset'
export const ONE_ASSET: OptionTab = '1-asset'
export const ALL_ASSET: OptionTab = 'all-asset'

export const DepositPopup: FC<Props> = ({ onExit, onDeposit, line }: Props) => {
  const pool = line.pool
  const one = ONE_ASSET
  const multi = ALL_ASSET

  const [showNavigator, setShowNavigator] = useState(true)
  const [option, setOption] = useState<OptionTab>(one)
  const headerAlignSelf = showNavigator ? 'center' : 'flex-start'
  const [slippage, setSlippage] = useState<number>(defaultSlippage)
  const [showSettings, setShowSettings] = useState(false)

  const [currentDeposit, depositDispatcher] = useReducer(depositReducer, {
    depositTab: '1-asset',
    mode: '1_asset_with_aggregator',
    pool,
  })

  useEffect(() => {
    initComponent()
    depositDispatcher({ type: 'choose-pool', pool })
  }, [])

  useEffect(() => {
    window.applicationContext.optionTab = option
    depositDispatcher({ type: 'change-tab', tab: option })
  }, [option])

  function initComponent() {
    // slippage from localStorage. It's a 0.003 to represent '0.3%'
    const lsSlippage = window.localStorage.getItem('slippage')
    if (lsSlippage) {
      setSlippage(parseFloat(lsSlippage))
    }
  }
  return (
    <PopupStyleWrapper className={'deposit-wrapper'}>
      <VerticalBox className={'deposit-vertical-box'}>
        <DepositHeader
          className={'deposit-header'}
          style={{ alignSelf: headerAlignSelf }}
        >
          {showNavigator && (
            <div className={'justify-between'} style={{ width: '100%' }}>
              <SubNavigator
                options={[one, multi]}
                onChange={option => {
                  setOption(option as OptionTab)
                  if (option === one) {
                    createEarnTabEvent(pool).clicked_one_asset_tab(
                      getOneAssetJoinTokens(pool)[0].symbol
                    )
                  } else {
                    createEarnTabEvent(pool).clicked_all_asset_tab(
                      listTokens(pool)
                    )
                  }
                }}
                selected={option}
              />
              <Gear
                onClick={() => {
                  createEarnTabEvent(pool).clicked_settings(
                    option as any,
                    slippage
                  )
                  setShowSettings(true)
                }}
                className={'mr20 align-center'}
              />
            </div>
          )}
        </DepositHeader>
        {option === one && (
          <OneAssetPanel
            pool={pool}
            onDeposit={(depositResult: DepositResult) => {
              onDeposit(depositResult)
              fireSuccessEvent(depositResult, option)
            }}
            onExit={onExit}
            onFail={fail => {
              onExit()
              //fireDepositFailureEvent()
            }}
            slippage={slippage}
            onHideNavigation={(hide: boolean) => {
              setShowNavigator(!hide)
              setOption(one)
            }}
            depositDispatcher={depositDispatcher}
          />
        )}
        {option === multi && (
          <MultiAssetPanel
            pool={pool}
            onDeposit={(depositResult: DepositResult) => {
              onDeposit(depositResult)
              fireSuccessEvent(depositResult, option)
            }}
            onExit={onExit}
            onFail={onExit}
            onHideNavigation={(hide: boolean) => {
              setShowNavigator(!hide)
              setOption(multi)
            }}
            depositDispatcher={depositDispatcher}
          />
        )}
        {/*</Popup>*/}
      </VerticalBox>
      {showSettings && (
        <Settings
          onExit={() => setShowSettings(false)}
          currentSlippage={slippage}
          onSlippageChange={newSlippage => {
            console.log('changing slippage to', newSlippage)
            setSlippage(newSlippage)
            createEarnTabEvent(pool).changed_slippage_tolerance(
              option as any,
              slippage,
              newSlippage
            )
          }}
          context={'lp'}
        />
      )}
    </PopupStyleWrapper>
  )
}

const DepositHeader = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  white-space: nowrap;
`

export const VerticalBox = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
`

export const PopupStyleWrapper = styled.div`
  font-size: 1.6rem;
  display: flex;
  justify-content: center;
  border-radius: 5rem;
  background-color: white;
  padding: 1.5rem 3rem;
  background-color: ${({ theme }) => theme.tradePanelBackgroundColor};
  width: 500px;
`

function fireSuccessEvent(depositResult: DepositResult, option: string) {
  oracleApi.getPrices().then(() => {
    createSuccessEvent().deposit_success(
      depositResult.hash,
      depositResult.pool.address,
      depositResult.pool.tokens.map(t => t.symbol),
      option,
      depositResult.bringIn.toAnalyticObject(),
      Amounts.fromMap(depositResult.amounts).toAnalyticObject(),
      fromWei(depositResult.value, 18),
      oracleApi.calculateBag(Amounts.fromMap(depositResult.amounts)),
      modeToEvent(depositResult.mode)
    )
  })
}

function modeToEvent(
  mode: 'all-asset' | '1-asset' | 'aggregator'
): DepositMode {
  switch (mode) {
    case 'all-asset':
      return 'all_asset'
    case '1-asset':
      return '1_asset_with_swaap'
    case 'aggregator':
      return '1_asset_with_aggregator'
  }
}
